const validation = {
  required: "This field is required.",
  minLength: "Please enter no more than {{min}} characters.",
  maxLength: "Please enter no more than {{max}} characters.",
  invalidURL: "Please enter a valid URL.",
  noCredit: "You do not have enough credits.",
};
export default validation;
